module.exports = __webpack_public_path__ + "static/media/Geenwood Park Associated  Amended and Restated Master Deed - 2010.80f0621f.pdf";